export default {
explore_by: "Buscar por",
explore_by_concepts: "Ideas",
explore_by_families: "Familias olfativas",
language: "idioma",
legal: "legal",
find_any_fragrance: "encontrar cualquier fragancia del mundo.",
title_by_concepts: "búsqueda por ideas",
desc_by_concepts: "encuentra tu perfume pensando en tu color o lugar preferido",
title_by_families: "búsqueda por famílias olfativas",
desc_by_families: "encuentra tu perfume pensando en tu...",
expert_reviewed: "revisado por expertos",
ingredients: "ingredientes",
description: "descripción",
perfumist: "perfumista",
concepts: "conceptos",
olfactive_family: "familia olfativa",
main_family: "familia",
sub_family: "sub-familia",
me_family: "Fragrances of the World",
filter_by_family: "familias",
filter_by_brand: "marcas",
filter_by_gender: "género",
for_him: "Para él",
for_her: "Para ella",
unisex: "Unisex",
all: "Todos",
all_female: "Todas",
concepts_list: "Lista de conceptos",
no_results_for_this_combination: "No hay perfumes para esta combinación",
select_at_least_one_concept: "Selecciona al menos un concepto",
view_perfumes: "ver perfumes",
back: "Volver",
close: "Cerrar",
filters: "Filtros",
selected_concepts: "Conceptos seleccionados:",
selected_families: "Familias seleccionadas:",
find_concept: "Buscar conceptos...",
smell_of: "Olor a",
touch_of: "Con un toque de",
loading_perfumes: "cargando los perfumes",
loading_concepts: "cargando los conceptos",
apply: "aplicar",
search: "buscar por",
clear_all: "borrar todo",
iconic_fragrances: "Perfumes icónicos en esta familia",
is_there_anybody_here: "",
continue_previous_session: "",
reset_session: "",
ingredient_type: "Tipo",
ingredient_parts: "Partes usadas",
ingredient_extraction: "Método de extracción",
ingredient_first: "Perfume Icónico",
history: "Historia",
effect: "Producción y efectos",
origin: "Origen",
iconic_fragrance: "Perfume icónico de este ingrediente",
production: "Producción",
loyalty_become_a_member: "Únete al club",
loyalty_avolta_link: "https://qr.clubavolta.com/register?source=ctOffline-scDuty_Free-sgAirport&campaign=Fragrance_Finder_Tools"
}